import { Instance, SnapshotOut, types } from 'mobx-state-tree';
import { CodeModel } from 'src/models/common-code/CommonCode';
import { withSetPropAction } from 'src/models/extensions/withSetPropAction';
import { OperatorInfo } from 'src/models/operator-info/OperatorInfo';

/**
 * # News
 *
 * News을 설명하세요.
 */
export const News = types
  .model('News')
  .props({
    no: types.number,
    newsSid: types.number,
    prNewsCtgyCd: types.maybeNull(CodeModel),
    title: types.maybeNull(types.string),
    descript: types.maybeNull(types.string),
    source: types.maybeNull(types.string),
    link: types.maybeNull(types.string),
    filePath: types.maybeNull(types.optional(types.array(types.string), [])),
    useYn: types.optional(types.boolean, false),
    regUser: types.maybeNull(OperatorInfo),
    updUser: types.maybeNull(OperatorInfo),
    regDt: types.optional(types.maybeNull(types.number), 0),
    updDt: types.optional(types.maybeNull(types.number), 0),
    originRegDt: types.optional(types.maybeNull(types.number), 0),
  })
  .actions(withSetPropAction);

// --------------------------------------------------------------------------
type TNews = Instance<typeof News>;
type TNewsSnapshot = SnapshotOut<typeof News>;

export interface INews extends TNews {}
export type TNewsKeys = keyof TNewsSnapshot & string;
export interface INewsSnapshot extends TNewsSnapshot {}
export const createNews = () => types.optional(News, {} as TNews);
